module.exports = __webpack_public_path__ + "c3bb1cea89d02911e85983d3cc817746.ttf";